import React from "react";
import { Navigate } from "react-router-dom";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";
import BasicSignUp from "../pages/AuthenticationInner/Register/BasicSignUp";
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";
//pages

import Maintenance from "../pages/Pages/Maintenance/Maintenance";
import ComingSoon from "../pages/Pages/ComingSoon/ComingSoon";

import CoverPasswReset from "../pages/AuthenticationInner/PasswordReset/CoverPasswReset";
import BasicLockScreen from "../pages/AuthenticationInner/LockScreen/BasicLockScr";
import CoverLockScreen from "../pages/AuthenticationInner/LockScreen/CoverLockScr";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

import AuthCallback from "../pages/Authentication/AuthCallback";

import MenuNavegacion from "../pages/MenuInicio/MenuNavegacion";
import { menuItems2 } from "../Layouts/LayoutMenuData";
import ReactTable from "../pages/Tables/ReactTables";
import Seguridad from "../pages/Configuracion/Seguridad";
import BasicElements from "../pages/Configuracion/Seguridad/BasicElements";
import MenuPermissions from "../pages/MenuPermissions";
import Citas from "../pages/Citas";
import RecepcionVehiculos from "../pages/RecepcionVehiculos";
import FileManager from "../pages/FileManager";
import ContabilidadDocumentosPendientes from "../pages/ContabilidadDocumentosPendientes";
import DteRecibidos from "../pages/DteRecibidos";
import Vehiculos from "../pages/Vehiculos";
import Clientes from "../pages/Clientes";
import NotificacionesCobranza from "../pages/NotificacionesCobranza";
import RendicionesFondos from "../pages/RendicionesFondos";
import MaestroDCV from "../pages/MaestroDCV";
import PlantillasCobranza from "../pages/PlantillasCobranza";
import OrdenesCompra from "../pages/OrdenesCompra";
import MenuItems from "../pages/MenuItems";
import SmtpCredentials from "../pages/SmtpCredentials";
import BarcodeScannerDemo from "../pages/BarcodeScannerDemo";
import OrdenesTrabajo from "../pages/OrdenesTrabajo";

const flattenArray = (arr) => {
  const result = [];
  arr.forEach((item) => {
    result.push(item);
    if (item.subItems && Array.isArray(item.subItems)) {
      result.push(...flattenArray(item.subItems));
    }
    if (item.childItems && Array.isArray(item.childItems)) {
      result.push(...flattenArray(item.childItems));
    }
  });
  return result;
};

const itemsAplanados = flattenArray(
  menuItems2//.filter((item) => item.description)
);

const authProtectedRoutes = []
  .concat(
    itemsAplanados
      .filter((item) => item.subItems && Array.isArray(item.subItems))
      .map((item) => ({
        path: item.link,
        component: <MenuNavegacion items={item.subItems} />,
      }))
  )
  .concat(
    itemsAplanados
      .filter((item) => item.childItems && Array.isArray(item.childItems))
      .map((item) => ({
        path: item.link,
        component: <MenuNavegacion items={item.childItems} />,
      }))
  )
  .concat([
    {
      path: "/menu-inicio",
      component: (
        <MenuNavegacion
          items={itemsAplanados?.filter((item) => !(item.parentId))?.filter((item) => item.description)}
        />
      ),
    },

    {
      path: "/contabilidad/documentos-pendientes",
      component: <ContabilidadDocumentosPendientes />,
    },
    {
      path: "/contabilidad/notificaciones-cobranza",
      component: <NotificacionesCobranza />,
    },
    {
      path: "/contabilidad/plantillas",
      component: <PlantillasCobranza />,
    },
    {
      path: "/contabilidad/rendiciones-fondos",
      component: <RendicionesFondos />,
    },
    {
      path: "/contabilidad/maestro-dcv",
      component: <MaestroDCV />,
    },
    {
      path: "/bodega/ordenes-compra",
      component: <OrdenesCompra />,
    },
    {
      path: "/external/dte-recibidos",
      component: <DteRecibidos />,
    },
    {
      path: "/bodega/maestro-productos",
      component: <BasicElements />,
    },
    {
      path: "/configuracion/seguridad",
      component: <Seguridad />,
    },
    {
      path: "/configuracion/menu-permissions",
      component: <MenuPermissions />,
    },
    {
      path: "/configuracion/menu-items",
      component: <MenuItems />,
    },
    {
      path: "/configuracion/credenciales-smtp",
      component: <SmtpCredentials />,
    },
    {
      path: "/demos/barcode-scanner",
      component: <BarcodeScannerDemo />,
    },
    {
      path: "/servicios/citas",
      component: <Citas />,
    },
    {
      path: "/servicios/vehiculos",
      component: <Vehiculos />,
    },
    {
      path: "/servicios/ordenes-trabajo",
      component: <OrdenesTrabajo />,
    },
    {
      path: "/caja-facturacion/maestro-clientes",
      component: <Clientes />,
    },
    {
      path: "/servicios/historial-recepciones",
      component: <RecepcionVehiculos />,
    },
    {
      path: "/file-transfer",
      component: <FileManager />,
    },
    {
      path: "/",
      exact: true,
      component: <Navigate to="/menu-inicio" />,
    },
    { path: "*", component: <Navigate to="/menu-inicio" /> },
  ]);

const publicRoutes = [
  { path: "/callback", component: <AuthCallback /> },

  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-coming-soon", component: <ComingSoon /> },


  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes };
